module.exports = __webpack_public_path__ + "img/goods07.79938cab.jpg";